<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="fnPopDetail()">创建问卷</el-button>
          </el-form-item>
          <el-form-item label-width="35px" class="fn-left">
            <Select key="11" style="width:140px" :selected.sync="listQuery.type" :data="currentBusinessType" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetQuestionnaireList()">搜索</el-button>
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnPopSearch('tuolele')">查看托管合适学员</el-button>
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnPopSearch('smallclass')">查看班课合适学员</el-button>
          </el-form-item>
          <el-form-item label="" class="fn-left" />
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="问卷名称" prop="name" align="center" />
        <el-table-column label="业务" prop="type_name" align="center" />
        <el-table-column label="问卷题目数量" prop="num" align="center" />
        <el-table-column label="发布时间" prop="release_time" align="center" />
        <el-table-column label="奖励优豆" prop="point" align="center" />
        <el-table-column label="截止填写时间" prop="deadline" align="center" />
        <el-table-column label="发布状态" align="center">
          <template slot-scope="{row}">
            {{ row.status == "0" ? "未发布" : "已发布" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button v-if="row.status == 0" type="text" @click="fnPopRelease(row.id)">发布问卷</el-button>
            <el-button v-if="row.status == 0" type="text" @click="fnPopDetail(row.id)">编辑问卷</el-button>
            <el-button v-if="row.status == 2" type="text" @click="fnPopDetail(row.id)">查看问卷</el-button>
            <el-button v-if="row.status == 2" type="text" @click="fnToAnalysis(row.id)">问卷分析</el-button>
            <el-button v-if="row.status == 1" type="text" @click="fnCancelRelease(row.id)">取消发布</el-button>
            <el-button type="text" @click="fnCopy(row.id)">复制问卷</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="listQuery.total" :page-size="listQuery.limit" @current-change="fnGetQuestionnaireList" />
    </div> -->
    <el-dialog
      title="查找合适学员"
      :visible.sync="bSearchDialog"
      class="combo-details"
      width="900px"
    >
      <user-select-search :search-type="searchType" />
    </el-dialog>
    <el-dialog
      title="发布问卷-文启优思公众号"
      :visible.sync="bReleaseQuestion"
      class="combo-details"
      width="900px"
    >
      <el-form :model="releasePostForm" label-width="120px">
        <el-form-item label="发送方式">
          <el-radio-group v-model="releasePostForm.send_type">
            <el-radio label="1">立即发送</el-radio>
            <el-radio label="2">定时发送</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="releasePostForm.send_type == '2'" label="定时发送时间">
          <el-date-picker v-model="releasePostForm.release_time" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-input v-model="releasePostForm.subIds" rows="5" type="textarea" placeholder="请输入学员长ID(逗号分隔，可通过查找适合学员获得)" />
        <el-button style="margin-top: 20px;" type="primary" @click="fnRelease()">确认发送</el-button>
      </el-form></el-dialog>
  </div>

</template>
<script>

import commondata from '@/utils/commondata'
import UserSelectSearch from '@/components/UserSelectSearch'
import Select from '@/components/Select'

const defaultReleasePostForm = {
  id: '',
  send_type: '1',
  release_time: '',
  subIds: ''
}
// import { validateRequire } from '@/utils/validate'
// import Tool from '@/assets/js/tool.js'

export default {
  name: 'StockExerciseList',
  components: {
    UserSelectSearch,
    Select
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      searchType: 'tuolele',
      bSearchDialog: false,
      bReleaseQuestion: false,
      currentBusinessType: [{ id: '', name: '全部' }, ...commondata.BUSSINESS_TYPE],
      listQuery: {
        p: 1,
        limit: 20,
        status: '0',
        type: '',
        is_open: '',
        total: 0,
        name: ''
      },
      releasePostForm: Object.assign({}, defaultReleasePostForm),
      openTypes: [{
        id: '0',
        name: '未发布'
      }, {
        id: '1',
        name: '已发布'
      }],
      opinionStatus: commondata.OPINION_STATUS
    }
  },
  created() {
    this.fnGetQuestionnaireList()
  },
  methods: {
    fnGetQuestionnaireList: function() {
      this.bCreateReply = false
      this.$http.getQuestionnaireList(this.listQuery).then(res => {
        this.lists = res.data
        // this.listQuery.total = parseInt(res.data.count)
      })
    },
    fnPopSearch(searchType) {
      this.searchType = searchType
      this.bSearchDialog = true
    },
    fnPopDetail: function(id) {
      this.$router.push({
        path: 'QuestionnaireDetail',
        query: { id }
      })
    },
    fnPopRelease(id) {
      this.releasePostForm.id = id
      this.bReleaseQuestion = true
    },
    fnRelease() {
      if (this.releasePostForm.send_type == '2' && !this.releasePostForm.release_time) {
        this.$message({
          type: 'warning',
          message: '请选择定时发送时间'
        })
        return
      }
      this.$confirm('确认发送问卷么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.$http.releaseWeekReport(this.releasePostForm).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '发布成功!'
            })
            this.releasePostForm.subIds = ''
            this.bReleaseQuestion = false
            this.fnGetQuestionnaireList()
          }
        })
      })
    },
    fnCopy(copyId) {
      this.$http.copyQuestionnaire({ copyId }).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '复制成功!'
          })
          this.fnGetQuestionnaireList()
        }
      })
    },
    fnToAnalysis(id) {
      this.$router.push({
        path: 'QuestionnaireAnalysis',
        query: { id }
      })
    },
    fnCancelRelease(id) {
      this.$confirm('确认取消发布么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.$http.cancelReleaseQuestionnaire({ id }).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            this.fnGetQuestionnaireList()
          }
        })
      })
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
